import { Translate } from 'next-translate';

/**
 * Resolves the display label for the buyer export's price/baseline column.
 * Price-update events retitle it to "Current Agreed Price per Unit", mirroring the buyer HoT
 * (generateTableConfiguration forces the same single-column title for price-update). Every other
 * event type carries the baseline wording.
 */
const getPricePerUnitHeader = (t: Translate, isPriceUpdate: boolean): string => (
  isPriceUpdate ? t('general.current_agreed_price_per_unit') : t('general.baseline_price_per_unit')
);

/**
 * Maps export column keys to their translated header labels.
 *
 * suggestedPricePerUnit resolves to `line_items.suggested_price` ("Suggested Price") — the same
 * key the buyer HoT header uses (HEADER_COPY in @features/suggested-price-column) and the same
 * label the OneSchema import template carries, so the header round-trips download → upload and
 * auto-maps. Deliberately NOT `line_items.suggested_price_per_unit`: that key titles the
 * supplier grid and is event-level renameable (CLIENT_I18N_KEY.suggestedPricePerUnit), so it is
 * not ours to reuse here.
 */
export const getTranslatedDefaultHeadersMap = (
  t: Translate,
  canImportPostSubmission = false,
  isPriceUpdate = false
) => ({
  discount: t('general.discount_per_unit'),
  extendedQuantity: t('line_items.quantity_of_units'),
  id: canImportPostSubmission ? t('general.arkestro_internal_id') : t('bid_request.line_item_id'),
  name: t('general.name'),
  negotiationPricePerUnit: t('line_items.negotiation_price_per_unit'),
  noBid: t('general.no_bid'),
  pricePerUnit: getPricePerUnitHeader(t, isPriceUpdate),
  quantity: t('line_items.items_per_unit'),
  quantityOfUnits: t('line_items.quantity_of_units'),
  required: t('general.required'),
  suggestedPricePerUnit: t('line_items.suggested_price'),
  surcharge: t('general.surcharge'),
  unitOfMeasure: t('general.uom'),
});
